<template>
  <svg
    xmlns="http://www.w3.org/2000/svg" width="22.627"
    height="22.615" viewBox="0 0 22.627 22.615"
  >
    <g
      id="그룹_204" data-name="그룹 204"
      transform="translate(0 0)"
    >
      <g
        id="그룹_204-2" data-name="그룹 204"
        class="cls-2" transform="translate(0 0)"
      >
        <path
          id="패스_460" data-name="패스 460"
          class="cls-1"
          d="M12.7.081,9.426,5.743h11.73A11.285,11.285,0,0,0,12.7.081M2.282,4.5,5.551,10.16,11.416,0A11.285,11.285,0,0,0,2.282,4.5M.9,15.724H7.44L1.574,5.566A11.283,11.283,0,0,0,.9,15.724m9.031,6.809,3.27-5.662H1.473a11.284,11.284,0,0,0,8.46,5.662m10.413-4.417-3.268-5.662L11.212,22.613a11.281,11.281,0,0,0,9.133-4.5M21.727,6.89H15.189l5.865,10.158A11.283,11.283,0,0,0,21.727,6.89"
          transform="translate(0 0)"
        />
      </g>
    </g>
  </svg>
</template>